module.exports = __webpack_public_path__ + "img/e18ed4f.png";